export default __webpack_public_path__ + "static/media/obj2.b5ddfa18.jpg";